<template>
  <div class="page-bottom-warp">
    <div class="content">
      <div class="left">
        <img src="../common/images/qzCollege/bottom_logo_2.png" alt="">
        <img src="../common/images/qzCollege/bottom_logo_3.png" alt="">
      </div>
      <div class="right">
        <a href="https://deepthink163.com/" target="_blank">
          <img src="../common/images/qzCollege/bottom_logo_1.png" alt="">
        </a>
      </div>
    </div>
    <div class="filing-info">
      <p>网站备案号：浙ICP备2021019571号-14</p>
      <p>主办单位名称：	杭州网易临界点教育科技有限公司</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PageFooter'
}
</script>

<style scoped lang="less">
.page-bottom-warp{
  background-image: url('../common/images/qzCollege/bottom_bg.png'), linear-gradient(rgba(10, 10, 10, 0.8), rgba(10, 10, 10, 0.8));
  background-blend-mode: multiply;
  background-position: center right;
  background-repeat: no-repeat;
  background-size: cover;
  width: 100%;
  padding: 8vh 0;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  .content{
    display: flex;
    justify-content: center;
    .right{
      width: 10.2vw;
      max-width: 390px;
      height: auto;
      img{
        width: 100%;
        height: auto;
      }
    }
    .left{
      padding-right: 5vw;
      margin-right: 5vw;
      border-right: 1px solid #FFFFFF33;
      margin-bottom: 3vh;
      img{
        &:first-child{
          width: 21.7vw;
          max-width: 834px;
          height: auto;
          margin-bottom: 3vh;
        }
        &:last-child{
          width: 10.2vw;
          max-width: 392px;
          height: auto;
        }
      }
    }
  }
  .filing-info{
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    bottom: 10px;
    left: 50%;
    gap: 20px;
    transform: translateX(-50%);
    p {
      font-size: clamp(10px, 0.625vw, 24px);
      color: rgba(225, 225, 225, 0.6);
    }
  }
}
</style>
